import trackEvent from '../../helpers/gtm/eventPush';

const backButton = document.querySelector('.lhs');
function trackingStepBack() {
  if (backButton) {
    const targetLink = backButton.getAttribute('href');
    const innerTextOfTheButton = backButton.innerText;
    const noSpaces = innerTextOfTheButton.replaceAll(/\s+/g, '_');
    const linkName = noSpaces.toLocaleLowerCase();
    backButton.addEventListener('click', () => {
      trackEvent({
        category: 'secondary_nav',
        action: `${linkName}`,
        label: `target=${targetLink}`,
      });
    });
  }
}

export default trackingStepBack;
